var map = {
	"./business_chat.svg": "2277",
	"./business_messages.svg": "aceb",
	"./direct_messages.svg": "21ee",
	"./email.svg": "2bb0",
	"./instagram.svg": "4b1b",
	"./marktplaats.svg": "ae48",
	"./messenger.svg": "04d0",
	"./sms.svg": "b7bf",
	"./telegram.svg": "5a5e",
	"./test.svg": "6f7b",
	"./web.svg": "071b",
	"./whatsapp.svg": "ad16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5992";